import React, { useState, useEffect } from 'react';
import siteData from '../data/siteData.json';
import useAdminMode from '../hooks/useAdminMode';
import EditModal, { SectionEditBtn } from '../components/EditModal';
import adminApi from '../api/adminClient';
import api from '../api/client';
import './Services.css';

export default function Services() {
  const [services, setServices] = useState(siteData.services);
  const [activeService, setActiveService] = useState(siteData.services[0].id);
  const [modal, setModal] = useState(false);
  const { isAdmin } = useAdminMode();
  const { process } = siteData;

  useEffect(() => {
    api.get('/site-content/services').then(setServices).catch(() => {});
  }, []);
  const active = services.find(s => s.id === activeService) || services[0];

  async function handleSaveServices(val) {
    try {
      await adminApi.put('/site-content/services', val);
      setServices(val);
      setModal(false);
    } catch (err) {
      alert(err.message);
    }
  }

  return (
    <main>
      <div className="page-header">
        <div className="container">
          <h1>사업영역</h1>
          <p>허브의 전문 아웃소싱 서비스를 소개합니다</p>
          <div className="breadcrumb">
            <span>HOME</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
            <span className="current">사업영역</span>
          </div>
        </div>
      </div>

      {/* Service selector */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">Our Services</span>
            <h2>
              허브의 전문 서비스
              {isAdmin && <SectionEditBtn onClick={() => setModal(true)} />}
            </h2>
            <p>기업의 인력 문제를 해결하는 검증된 아웃소싱 솔루션</p>
            <div className="divider" />
          </div>

          <div className="service-nav">
            {services.map(svc => (
              <button
                key={svc.id}
                className={`service-nav__btn ${activeService === svc.id ? 'service-nav__btn--active' : ''}`}
                onClick={() => setActiveService(svc.id)}
              >
                {svc.title}
              </button>
            ))}
          </div>

          {active && (
            <div className="service-detail">
              <div className="service-detail__info">
                <h3>{active.title}</h3>
                <p>{active.description}</p>
                <ul className="service-detail__features">
                  {active.features.map((f, i) => (
                    <li key={i}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                      {f}
                    </li>
                  ))}
                </ul>
                <a href="/contact" className="btn btn-primary">상담 신청하기</a>
              </div>
            </div>
          )}
        </div>
      </section>

      {modal && (
        <EditModal
          title="서비스 목록 편집 (JSON)"
          value={services}
          onSave={handleSaveServices}
          onClose={() => setModal(false)}
        />
      )}

      {/* Process */}
      <section className="section section--gray">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">Process</span>
            <h2>업무 진행 프로세스</h2>
            <p>체계적인 6단계 프로세스로 최적의 결과를 보장합니다.</p>
            <div className="divider" />
          </div>
          <div className="process-steps">
            {process.map((step, i) => (
              <div key={step.step} className="process-step">
                <div className="process-step__num">{String(step.step).padStart(2, '0')}</div>
                <div className="process-step__arrow">
                  {i < process.length - 1 && (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                  )}
                </div>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Effects */}
      <section className="section section--navy">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">Benefits</span>
            <h2>기대 효과</h2>
            <div className="divider" style={{ background: 'var(--blue-300)' }} />
          </div>
          <div className="effects-grid">
            {[
              { icon: '💰', title: '비용 절감', desc: '채용·교육·복리후생 비용 20~30% 절감 효과', num: '20~30%' },
              { icon: '⚡', title: '즉각적인 인력 확보', desc: '공석 발생 시 48시간 이내 대안 인력 제공', num: '48h' },
              { icon: '🎯', title: '핵심 업무 집중', desc: '비핵심 업무 위탁으로 경쟁력 강화', num: '∞' },
              { icon: '🛡️', title: '법적 리스크 최소화', desc: '노동법·파견법 준수로 고객사 리스크 제로화', num: '0' },
            ].map((e, i) => (
              <div key={i} className="effect-card">
                <div className="effect-card__num">{e.num}</div>
                <div className="effect-card__icon">{e.icon}</div>
                <h4>{e.title}</h4>
                <p>{e.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

